var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#5764EB",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_3043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 36V35H30C22.821 35 17 29.179 17 22C17 21.446 17.446 21 18 21H20C27.179 21 33 26.821 33 34V36V46C33 46.554 32.554 47 32 47C31.446 47 31 46.554 31 46V36ZM47 18C47 24.2584 42.575 29.4873 36.686 30.7208C36.1222 27.837 34.8318 25.2145 33.0129 23.0547C35.3168 19.4159 39.3774 17 44 17H46C46.554 17 47 17.446 47 18Z",
    fill: "#5764EB",
    stroke: "#5764EB",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_3043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.e7f5799f23c43025b118b13d63a95fa6.svg";
export { ForwardRef as ReactComponent };